import {
  orderServiceFindOneQuery,
  orderServiceListQuery,
} from "./orderService";

const model = "functions";

export const useFunction = orderServiceFindOneQuery({ model });
export const useFunctionList = orderServiceListQuery({ model });
